import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rc_lang") || "es");

  useEffect(() => {
    localStorage.setItem("rc_lang", lang);
    document.documentElement.lang = lang === "eu" ? "eu" : "es";
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "es" ? "eu" : "es"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
};
